import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthLayoutService } from '../auth-layout/auth-layout.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private accountService: AuthLayoutService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                // this.accountService.logout();
                const error = err.error.message || err.statusText;
                return throwError(error);
            }
            else if (err.status === 400) {
                // auto logout if 400 response returned from api
                // this.accountService.logout();
                const error = err.error.message || err.statusText;
                return throwError(error);
            }
            
            const error = err.error.message || err.statusText;
            return throwError(error);
        }))
    }
}